<template>
    <q-item clickable v-close-popup @click="onClickHandler">
        <q-icon v-if="!hideIcon" name="fa-regular fa-share default-grey-icon-color q-mr-xs" size="18px" color="black" />
        <q-item-section>{{ $t("shared.Copy link") }}</q-item-section>
    </q-item>
</template>

<script setup lang="ts">
import { useQuasar } from "quasar";
import { useClipboard } from "@vueuse/core";
import { useI18n } from "vue-i18n";

const props = defineProps<{ hideIcon?: boolean; onClick?: () => void }>();

const { t } = useI18n();
const { notify } = useQuasar();
const { copy } = useClipboard();

const onClickHandler = () => {
    // TODO: fix
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    props.onClick ? props.onClick() : shareClipboard();
};

const shareClipboard = () => {
    copy(window.location.href);
    notify({ message: t("shared.Link was successfully copied to the clipboard"), type: "positive" });
};
</script>
